<template>
	<el-dialog v-dialogDrag class="setting mine-profile-dialog" title="修改我的信息" :visible.sync="visible"
		width="560px" top="8vh" :before-close="onClose" append-to-body>
		<el-form :model="userInfo" label-width="118px" :rules="rules" ref="settingForm" size="small"
			class="mine-profile-form">
			<el-form-item label="头像" class="mine-profile-row avatar-row">
				<div class="avatar-control">
					<file-upload class="avatar-uploader" :action="imageAction" :showLoading="true" :maxSize="maxSize" :deferUpload="true"
						:isPermanent="true" @success="onUploadSuccess"
						:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
						<head-image :name="userInfo.nickName || userInfo.userName" :url="displayAvatarUrl" :size="72"
							radius="12px" :isShowUserInfo="false"></head-image>
					</file-upload>
					<button v-if="canRestoreDefaultAvatar" type="button" class="restore-avatar" @click.stop="restoreDefaultAvatar">
						恢复默认头像
					</button>
				</div>
			</el-form-item>
			<el-form-item label="用户名" class="mine-profile-row">
				<div class="readonly-value">{{ userInfo.userName || '-' }}</div>
			</el-form-item>
			<el-form-item prop="nickName" label="昵称" class="mine-profile-row">
				<el-input class="right-input" v-model="userInfo.nickName" autocomplete="off" size="small" maxlength="20"
					placeholder="请输入您的昵称"></el-input>
			</el-form-item>
			<el-form-item label="性别" class="mine-profile-row">
				<el-radio-group v-model="userInfo.sex" class="sex-group">
					<el-radio :label="0">男</el-radio>
					<el-radio :label="1">女</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="个性签名" class="mine-profile-row textarea-row">
				<el-input class="right-input" type="textarea" v-model="userInfo.signature" :rows="2" maxlength="64"
					placeholder="编辑个性签名,展示我的独特态度"></el-input>
			</el-form-item>
			<el-form-item label="我的简介" class="mine-profile-row textarea-row">
				<el-input class="right-input" type="textarea" v-model="userDetail.selfDescrip" :rows="2" maxlength="500"
					placeholder="介绍一下自己，让更多人了解你"></el-input>
			</el-form-item>
			<el-form-item label="我的联系方式" class="mine-profile-row">
				<el-input class="right-input" v-model="userDetail.selfContact" autocomplete="off" size="small"
					maxlength="100" placeholder="请输入联系方式"></el-input>
			</el-form-item>
			<el-form-item label="我的照片" class="mine-profile-row media-row">
				<div class="profile-photo-list">
					<div class="profile-photo-item" v-for="(photo, index) in profilePhotoSlots" :key="index">
						<template v-if="photo">
							<img class="profile-photo-image" :src="photo.thumbUrl || photo.originUrl" @click="previewImage(photo.originUrl || photo.thumbUrl)">
							<button type="button" class="media-delete" @click.stop="deletePhoto(index)">
								<i class="el-icon-close"></i>
							</button>
						</template>
						<file-upload v-else class="profile-add-upload" :action="imageAction" :showLoading="true" :deferUpload="true"
							:maxSize="maxSize" :isPermanent="true" @success="onPhotoUploadSuccess"
							:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
							<div class="profile-add-box photo-add">
								<span class="plus-icon">+</span>
								<span class="add-text">添加</span>
							</div>
						</file-upload>
					</div>
				</div>
			</el-form-item>
			<el-form-item label="我的视频" class="mine-profile-row media-row">
				<div class="profile-video-box">
					<div class="profile-video-item" v-if="userDetail.selfVideo">
						<img v-if="userDetail.selfVideoThumb" class="profile-video-thumb" :src="userDetail.selfVideoThumb"
							@click="playVideo(userDetail.selfVideo)">
						<video v-else class="profile-video-thumb" :src="userDetail.selfVideo" @click="playVideo(userDetail.selfVideo)"></video>
						<button type="button" class="media-delete" @click.stop="deleteVideo">
							<i class="el-icon-close"></i>
						</button>
					</div>
					<file-upload v-else class="profile-add-upload" :action="videoAction" :showLoading="true" :deferUpload="true"
						:maxSize="videoMaxSize" @success="onVideoUploadSuccess"
						:fileTypes="['video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo']">
						<div class="profile-add-box video-add">
							<span class="plus-icon">+</span>
							<span class="add-text">添加视频</span>
						</div>
					</file-upload>
				</div>
			</el-form-item>
		</el-form>

		<div slot="footer" class="dialog-footer">
			<el-button type="primary" class="submit-button" @click="onSubmit()">提交</el-button>
		</div>
	</el-dialog>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";
import HeadImage from "../common/HeadImage.vue";

export default {
	name: "setting",
	components: {
		FileUpload,
		HeadImage
	},
	data() {
		return {
			userInfo: {},
			userDetail: this.createEmptyUserDetail(),
			maxSize: 5 * 1024 * 1024,
			videoMaxSize: 100 * 1024 * 1024,
			action: "/image/upload",
			pendingAvatarFile: null,
			pendingAvatarDefault: false,
			pendingDeletedPhotoIndexes: [],
			pendingDeleteVideo: false,
			rules: {
				nickName: [{
					required: true,
					message: '请输入昵称',
					trigger: 'blur'
				}]
			}
		}
	},
	methods: {
		onClose() {
			this.$emit("close");
		},
		createEmptyUserDetail() {
			return {
				selfDescrip: '',
				selfImages: [],
				selfVideo: '',
				selfVideoThumb: '',
				selfContact: ''
			};
		},
		normalizeUserDetail(data) {
			if (!data) {
				return this.createEmptyUserDetail();
			}
			const processedImages = Array.isArray(data.selfImages)
				? data.selfImages.map((imgUrl, index) => {
					if (typeof imgUrl === 'object' && imgUrl !== null) {
						return {
							originUrl: imgUrl.originUrl || imgUrl.url || '',
							thumbUrl: imgUrl.thumbUrl || imgUrl.originUrl || imgUrl.url || '',
							serverIndex: index + 1
						};
					}
					const thumbUrl = (Array.isArray(data.selfImageThumbs) && data.selfImageThumbs[index]) || imgUrl;
					return {
						originUrl: imgUrl,
						thumbUrl,
						serverIndex: index + 1
					};
				}).filter(item => item.originUrl || item.thumbUrl)
				: [];
			return {
				selfDescrip: data.selfDescrip || '',
				selfImages: processedImages,
				selfVideo: data.selfVideo || '',
				selfVideoThumb: data.selfVideoThumb || '',
				selfContact: data.selfContact || ''
			};
		},
		openDialogData() {
			const mine = this.userStore.userInfo || {};
			this.userInfo = JSON.parse(JSON.stringify(mine));
			this.userDetail = this.createEmptyUserDetail();
			this.pendingAvatarFile = null;
			this.pendingAvatarDefault = false;
			this.pendingDeletedPhotoIndexes = [];
			this.pendingDeleteVideo = false;
			this.loadUserDetail();
		},
		loadUserDetail() {
			this.$http({
				url: "/user/detail",
				method: "GET"
			}).then((data) => {
				this.userDetail = this.normalizeUserDetail(data);
			}).catch((err) => {
				console.error('获取用户详情失败:', err);
			});
		},
		buildUserDetailPayload() {
			const imageItems = Array.isArray(this.userDetail.selfImages) ? this.userDetail.selfImages : [];
			const selfImages = imageItems.map(img => img.originUrl || img.thumbUrl).filter(Boolean);
			const selfImageThumbs = imageItems.map(img => img.thumbUrl || img.originUrl).filter(Boolean);
			return {
				selfDescrip: this.userDetail.selfDescrip || '',
				selfContact: this.userDetail.selfContact || '',
				selfImages,
				selfImageThumbs,
				selfVideo: this.userDetail.selfVideo || '',
				selfVideoThumb: this.userDetail.selfVideoThumb || ''
			};
		},
		onSubmit() {
			this.$refs['settingForm'].validate((valid) => {
				if (!valid) {
					return false;
				}
				this.prepareDeferredProfileAssets().then(() => this.$http({
					url: "/user/update",
					method: "PUT",
					data: this.userInfo
				})).then(() => {
					this.userStore.setUserInfo(this.userInfo);
					return this.$http({
						url: "/user/detail",
						method: "PUT",
						data: this.buildUserDetailPayload()
					});
				}).then(() => {
					this.$emit("close");
					this.$message.success("修改成功");
				});
			});
		},
		onUploadSuccess(data, file) {
			this.pendingAvatarFile = file;
			this.pendingAvatarDefault = false;
			this.userInfo.headImage = data.originUrl;
			this.userInfo.headImageThumb = data.thumbUrl;
		},
		restoreDefaultAvatar() {
			this.$confirm('确定恢复默认头像吗？原头像文件将被删除。', '恢复默认头像', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.pendingAvatarFile = null;
				this.pendingAvatarDefault = true;
				this.userInfo.headImage = '';
				this.userInfo.headImageThumb = '';
				this.$message.success('已选择恢复默认头像，请提交后生效');
			}).catch(() => {});
		},
		onPhotoUploadSuccess(data, file) {
			if (this.userDetail.selfImages.length >= 3) {
				this.$message.warning('最多只能上传3张照片');
				return;
			}
			this.userDetail.selfImages.push({
				originUrl: data.originUrl,
				thumbUrl: data.thumbUrl || data.originUrl,
				localFile: data.localFile || file,
				pendingUpload: true
			});
			this.$message.success('已添加，请提交后生效');
		},
		deletePhoto(index) {
			this.$confirm('确定要删除这张照片吗？', '确认删除', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const photo = this.userDetail.selfImages[index];
				if (photo && photo.serverIndex) {
					this.pendingDeletedPhotoIndexes.push(photo.serverIndex);
				}
				this.userDetail.selfImages.splice(index, 1);
				this.$message.success('已删除，请提交后生效');
			}).catch(() => {});
		},
		onVideoUploadSuccess(data, file) {
			this.userDetail.selfVideo = data.originUrl;
			this.userDetail.selfVideoThumb = data.thumbUrl || '';
			this.userDetail.selfVideoFile = data.localFile || file;
			this.userDetail.selfVideoPendingUpload = true;
			this.pendingDeleteVideo = false;
			this.$message.success('已添加，请提交后生效');
		},
		deleteVideo() {
			this.$confirm('确定要删除这个视频吗？', '确认删除', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				if (this.userDetail.selfVideo && !this.userDetail.selfVideoPendingUpload) {
					this.pendingDeleteVideo = true;
				}
				this.userDetail.selfVideo = '';
				this.userDetail.selfVideoThumb = '';
				this.userDetail.selfVideoFile = null;
				this.userDetail.selfVideoPendingUpload = false;
				this.$message.success('已删除，请提交后生效');
			}).catch(() => {});
		},
		uploadDeferredFile(action, file, isPermanent = false) {
			const formData = new FormData();
			formData.append('file', file);
			return this.$http({
				url: `${action}?isPermanent=${isPermanent}`,
				data: formData,
				method: 'post',
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
		},
		applyPendingAvatar() {
			if (this.pendingAvatarDefault) {
				return this.$http({
					url: "/user/avatar/default",
					method: "PUT"
				}).then((userInfo) => {
					this.userInfo.headImage = userInfo.headImage || '';
					this.userInfo.headImageThumb = userInfo.headImageThumb || '';
					this.pendingAvatarDefault = false;
				});
			}
			if (!this.pendingAvatarFile) {
				return Promise.resolve();
			}
			return this.uploadDeferredFile(this.imageAction, this.pendingAvatarFile, true).then((data) => {
				this.userInfo.headImage = data.originUrl;
				this.userInfo.headImageThumb = data.thumbUrl || data.originUrl;
				this.pendingAvatarFile = null;
			});
		},
		applyPendingMediaDeletes() {
			const deletePhotos = [...new Set(this.pendingDeletedPhotoIndexes)]
				.sort((a, b) => b - a)
				.map((serverIndex) => this.$http({
					url: `/user/detail/image/${serverIndex}`,
					method: "DELETE"
				}));
			if (this.pendingDeleteVideo) {
				deletePhotos.push(this.$http({
					url: "/user/detail/video",
					method: "DELETE"
				}));
			}
			return Promise.all(deletePhotos).then(() => {
				this.pendingDeletedPhotoIndexes = [];
				this.pendingDeleteVideo = false;
			});
		},
		uploadPendingProfileMedia() {
			const photoUploads = this.userDetail.selfImages.map((photo) => {
				if (!photo || !photo.pendingUpload || !photo.localFile) {
					return Promise.resolve();
				}
				return this.uploadDeferredFile(this.imageAction, photo.localFile, true).then((data) => {
					photo.originUrl = data.originUrl;
					photo.thumbUrl = data.thumbUrl || data.originUrl;
					photo.localFile = null;
					photo.pendingUpload = false;
				});
			});
			let videoUpload = Promise.resolve();
			if (this.userDetail.selfVideoPendingUpload && this.userDetail.selfVideoFile) {
				videoUpload = this.uploadDeferredFile(this.videoAction, this.userDetail.selfVideoFile, false).then((data) => {
					this.userDetail.selfVideo = data.originUrl;
					this.userDetail.selfVideoThumb = data.thumbUrl || '';
					this.userDetail.selfVideoFile = null;
					this.userDetail.selfVideoPendingUpload = false;
				});
			}
			return Promise.all([...photoUploads, videoUpload]);
		},
		prepareDeferredProfileAssets() {
			return this.applyPendingAvatar()
				.then(() => this.applyPendingMediaDeletes())
				.then(() => this.uploadPendingProfileMedia());
		},
		previewImage(url) {
			if (!url) return;
			this.$eventBus.$emit("openFullImage", url);
		},
		playVideo(url) {
			if (!url) return;
			window.open(url, '_blank');
		}
	},
	props: {
		visible: {
			type: Boolean
		}
	},
	computed: {
		userAvatar() {
			return this.userInfo.headImageThumb || this.userInfo.headImage || '';
		},
		canRestoreDefaultAvatar() {
			return !!this.userAvatar;
		},
		displayAvatarUrl() {
			return this.userAvatar;
		},
		profilePhotoSlots() {
			return [0, 1, 2].map(index => this.userDetail.selfImages[index] || null);
		},
		imageAction() {
			return `/image/upload`;
		},
		videoAction() {
			return `/video/upload`;
		}
	},
	watch: {
		visible: function (value) {
			if (value) {
				this.openDialogData();
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.setting {
	::v-deep .el-dialog__body {
		padding: 0;
		background: #f6f7fb;
		max-height: 64vh;
		overflow-y: auto;
	}

	::v-deep .el-dialog__header {
		text-align: center;
		padding: 18px 48px 16px;
		border-bottom: 1px solid #edf0f5;
	}

	::v-deep .el-dialog__title {
		font-size: 18px;
		font-weight: 500;
		color: #111827;
	}

	::v-deep .el-dialog__footer {
		padding: 18px 32px 24px;
		background: #f6f7fb;
	}

	.el-form {
		padding: 16px 0 0;
	}

	.mine-profile-row {
		display: flex;
		align-items: center;
		min-height: 56px;
		margin: 0;
		padding: 0 28px;
		background: #ffffff;
		border-bottom: 1px solid #f0f2f5;
		box-sizing: border-box;

		::v-deep .el-form-item__label {
			padding: 0 18px 0 0;
			font-size: 15px;
			line-height: 56px;
			color: #111827;
			text-align: left;
		}

		::v-deep .el-form-item__content {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			margin-left: 0 !important;
			min-width: 0;
		}
	}

	.avatar-row {
		min-height: 112px;
	}

	.textarea-row {
		align-items: flex-start;
		padding-top: 10px;
		padding-bottom: 10px;

		::v-deep .el-form-item__label {
			line-height: 36px;
		}
	}

	.media-row {
		min-height: 92px;
		padding-top: 12px;
		padding-bottom: 12px;

		::v-deep .el-form-item__label {
			line-height: 68px;
		}
	}

	.readonly-value {
		color: #9ca3af;
		font-size: 14px;
	}

	.right-input {
		max-width: 360px;
		text-align: right;

		::v-deep .el-input__inner,
		::v-deep .el-textarea__inner {
			text-align: right;
			border: none;
			padding-right: 0;
			color: #111827;
			background: transparent;
			resize: none;
		}
	}

	.sex-group {
		.el-radio {
			margin-left: 26px;
			margin-right: 0;
		}
	}

	.el-radio__inner {
		border-color: #d1d5db !important;
		width: 22px;
		height: 22px;
	}

	.el-radio__inner::after {
		width: 8px;
		height: 8px;
		background-color: #ffffff !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #2f80ed !important;
		background-color: #2f80ed !important;
	}

	.el-radio .el-radio__label {
		color: #111827 !important;
		font-size: 15px;
	}

	.dialog-footer {
		text-align: center;

		.submit-button {
			width: 100%;
			height: 42px;
			border-radius: 6px;
			font-size: 16px;
			background: #2f80ed;
			border-color: #2f80ed;
			color: #ffffff;
		}
	}

	.avatar-uploader {
		--width: 72px;

		.el-upload {
			border: none !important;
			border-radius: 12px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.el-upload:hover {
			border-color: #409EFF;
		}

		.avatar-uploader-icon {
			font-size: 22px;
			color: #8c939d;
			width: var(--width);
			height: var(--width);
			line-height: var(--width);
			text-align: center;
			border-radius: 12px;
			border: 1px dashed #d9d9d9;
			box-sizing: border-box;
		}

		.avatar {
			width: var(--width);
			height: var(--width);
			display: block;
			border-radius: 12px;
			object-fit: cover;
			border: 1px solid #e5e7eb;
		}
	}

	.avatar-control {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 8px;
	}

	.restore-avatar {
		border: none;
		padding: 0;
		background: transparent;
		color: #2f80ed;
		font-size: 13px;
		line-height: 18px;
		cursor: pointer;
	}

	.profile-photo-list {
		display: flex;
		gap: 8px;
	}

	.profile-photo-item {
		position: relative;
		width: 72px;
		height: 72px;
		flex: 0 0 auto;
	}

	.profile-photo-image,
	.profile-video-thumb {
		width: 100%;
		height: 100%;
		display: block;
		object-fit: cover;
		border-radius: 6px;
		border: 1px solid #eef0f4;
		box-sizing: border-box;
		cursor: pointer;
	}

	.profile-add-upload {
		display: block;

		::v-deep .el-upload {
			display: block;
		}
	}

	.profile-add-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px dashed #2f80ed;
		border-radius: 6px;
		background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);
		color: #2f80ed;
		box-sizing: border-box;
		cursor: pointer;
	}

	.photo-add {
		width: 72px;
		height: 72px;
	}

	.video-add {
		width: 128px;
		height: 72px;
		border-color: #ff9aa2;
		color: #ff6b75;
		background: linear-gradient(135deg, #fff7f7 0%, #fff0f1 100%);
	}

	.plus-icon {
		font-size: 22px;
		line-height: 1;
	}

	.add-text {
		margin-top: 6px;
		font-size: 13px;
	}

	.profile-video-box {
		display: flex;
		justify-content: flex-end;
		width: 100%;
	}

	.profile-video-item {
		position: relative;
		width: 128px;
		height: 72px;
	}

	.media-delete {
		position: absolute;
		right: -7px;
		top: -7px;
		width: 20px;
		height: 20px;
		padding: 0;
		border: none;
		border-radius: 50%;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background: #ff4757;
		color: #ffffff;
		font-size: 12px;
		cursor: pointer;
	}
}
</style>
